import React from 'react';
import { Grid } from '@mui/material';
import Engagements from './engagements';
import MonthlyPrescriptionPerformance from './monthlyPrescriptionPerformance';
import TopPriscribers from './topPrescribers';
import Triggers from './triggers';
import { handleCustomisationForCompanyDashboard } from '../../../utility';
import WebsitePerformance from './websitePerformance';

const HcpDashboard = (props) => {
    const { selectedCompanyId } = props;
    const hide_prescribers = [97, 107].includes(selectedCompanyId);
    return (
        <>
            <Grid item xs={12}>
                <Grid container>
                    <Engagements />
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <Grid container spacing={3}>
                    <Grid
                        item
                        lg={hide_prescribers ? 12 : 9}
                        sx={{ zoom: { xs: '50%', lg: '100%' } }}
                        xs={12}
                    >
                        {handleCustomisationForCompanyDashboard(
                            selectedCompanyId,
                        ) ? (
                            <WebsitePerformance />
                        ) : (
                            <MonthlyPrescriptionPerformance />
                        )}
                        <Triggers />
                    </Grid>

                    {!hide_prescribers && (
                        <Grid item lg={3} xs={12}>
                            <TopPriscribers />
                        </Grid>
                    )}
                </Grid>
            </Grid>
        </>
    );
};

export default HcpDashboard;
